const prefix = 'ls';
let storageType = 'localStorage';

const getLocalStorageItem = (key) => {
  if (checkSupport()) {
    return window.localStorage.getItem(prefix + '.' + key);
  }
  return null;
};

const setLocalStorageItem = (key, value) => {
  if (checkSupport()) {
    window.localStorage.setItem(prefix + '.' + key, value);
    return true;
  }
  return false;
};

const checkSupport = () => {
  try {
    let supported = (storageType in window && window[storageType] !== null);

    // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
    // is available, but trying to call .setItem throws an exception.
    //
    // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage
    // that exceeded the quota."
    let key = '__' + Math.round(Math.random() * 1e7);
    if (supported) {
      let webStorage = window[storageType];
      webStorage.setItem(key, '');
      webStorage.removeItem(key);
    }
    return supported;
  } catch (e) {
    return false;
  }
};

module.exports = {
  getLocalStorageItem,
  setLocalStorageItem
};
